// src/components/GAPageTracker.js

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const GAPageTracker = () => {
  const location = useLocation(); // <-- useLocation() is now inside a component rendered *by* the Router

  useEffect(() => {
    // This effect runs whenever the 'location' object changes (i.e., route changes)
    // It sends a 'pageview' hit to Google Analytics
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
    console.log('GA4 Page View sent:', location.pathname + location.search); // Optional: for debugging
  }, [location]); // Dependency array includes 'location'

  // This component doesn't render any visible UI
  return null;
};

export default GAPageTracker;